<button
    class="flex justify-center items-center rounded-[10px] border-2 text-center h-full min-h-[30px] w-full transition duration-300 ease-in-out"
    [ngClass]="[isDisabled ? disabledBackgroundColor : backgroundColor, isDisabled ? disabledTextColor : textColor,
    isDisabled ? 'cursor-not-allowed' : '', isDisabled ? disabledBorderColor : borderColor, !isDisabled ? hoverBackgroundColor : '', !isDisabled ? hoverTextColor : '',
    !isDisabled ? hoverBorderColor : '', fontWeight 
    ]" [disabled]="isDisabled" (click)="onClick()" [title]="!isDisabled ? title : disabledTitle">
    <img *ngIf="leadingIcon" [src]="leadingIcon" [alt]="leadingIconAlt" class="w-5 h-5 mr-2" />
    {{ buttonText }}
    <span *ngIf="showSpinner" class="loading loading-spinner loading-sm ml-2"></span>
    <img *ngIf="trailingIcon" [src]="trailingIcon" [alt]="trailingIconAlt" class="w-5 h-5 ml-2" />
</button>